import { identity } from 'rxjs';
import { Endpoint } from '../endpoint';
import { CommentId, CommentResponse } from '@business/entities/comment';
import { TenantIdentity } from '@business/entities/common';
import { UserResponse } from '@business/entities/account';
import { R } from '@core/utils/r';

export function fetchComments(data: { objectId: string; type: string }, identity?: TenantIdentity, isPublic = false) {
  if (identity) {
    return Endpoint.get<CommentResponse[]>(`@gc/comments-identity`, { params: data, identity });
  }
  return Endpoint.get<CommentResponse[]>(isPublic ? `@gc/public/comments` : `@gc/comments`, { params: data });
}

export function fetchComment(id: CommentId, identity?: TenantIdentity) {
  if (identity) {
    return Endpoint.get<CommentResponse>(`@gc/comments-identity/comment/${id}`, { identity });
  }

  return Endpoint.get<CommentResponse>(`@gc/comments/comment/${id}`);
}

export function createComment(comment: Partial<CommentResponse>, identity?: TenantIdentity, user?: UserResponse | null) {
  if (identity) {
    return Endpoint.post<CommentResponse>(`@gc/comments-identity/create`, {
      data: { ...comment, userInfo: R.pick(user!, ['id', 'email', 'firstName', 'lastName']) },
      identity,
    });
  }

  return Endpoint.post<CommentResponse>(`@gc/comments/create`, { data: { ...comment } });
}

export function updateComment(id: CommentId, comment: Partial<CommentResponse>, identity?: TenantIdentity) {
  if (identity) {
    return Endpoint.patch<CommentResponse>(`@gc/comments-identity/${id}`, { data: { ...comment }, identity });
  }

  return Endpoint.patch<CommentResponse>(`@gc/comments/${id}`, { data: { ...comment } });
}

export function deleteComment(commentId: CommentId, identity?: TenantIdentity) {
  if (identity) {
    return Endpoint.delete<void>(`@gc/comments-identity/${commentId}`, { identity });
  }

  return Endpoint.delete<void>(`@gc/comments/${commentId}`);
}

export function syncToClickup(id: CommentId, identity?: TenantIdentity) {
  if (identity) {
    return Endpoint.get<CommentResponse>(`@gc/comments-identity/sync-to-clickup/${id}`, { identity });
  }

  return Endpoint.get<CommentResponse>(`@gc/comments/sync-to-clickup/${id}`);
}
